var map = {
	"./background-magazine.jpg": 32,
	"./background-wine.png": 33,
	"./bg-papier.jpg": 34,
	"./flags/be.svg": 35,
	"./flags/cn.svg": 36,
	"./flags/de.svg": 37,
	"./flags/es.svg": 38,
	"./flags/fr.svg": 39,
	"./flags/gb.svg": 40,
	"./flags/it.svg": 41,
	"./flags/jp.svg": 42,
	"./flags/us.svg": 43,
	"./icons/arrow-article.svg": 44,
	"./icons/back.svg": 45,
	"./icons/close.svg": 46,
	"./icons/error.svg": 47,
	"./icons/facebook.svg": 48,
	"./icons/info.svg": 49,
	"./icons/instagram.svg": 50,
	"./icons/linkedin.svg": 51,
	"./icons/marker.svg": 52,
	"./icons/pinterest.svg": 53,
	"./icons/slider-arrow.svg": 54,
	"./icons/success.svg": 55,
	"./icons/twitter.svg": 56,
	"./icons/weibo.svg": 57,
	"./icons/youtube.svg": 58,
	"./logo.png": 59,
	"./logo.svg": 60,
	"./marker.svg": 61,
	"./menu-bg.png": 62,
	"./pattern.png": 63,
	"./wine-shadow.png": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;